const REGISTRY = new Map();

module.exports = REGISTRY;
